export var StepType;
(function (StepType) {
    /** text-based step. */
    StepType["ARTICLE"] = "ARTICLE";
    /** step with video content. */
    StepType["VIDEO"] = "VIDEO";
    /** step containing quiz. */
    StepType["QUIZ"] = "QUIZ";
})(StepType || (StepType = {}));
export var Enum;
(function (Enum) {
    /** Default value. Means that permission not set */
    Enum["UNKNOWN"] = "UNKNOWN";
    /** Protected exposure. Exposed to members and owners */
    Enum["PROTECTED"] = "PROTECTED";
    /** Private exposure. Exposed to owners */
    Enum["PRIVATE"] = "PRIVATE";
    /** Public exposure. Visible to everyone */
    Enum["PUBLIC"] = "PUBLIC";
    /** Used for partial updates, to state that exposure is not changing */
    Enum["UNCHANGED"] = "UNCHANGED";
    /** Protected to members of permitted groups and owners */
    Enum["GROUP_PROTECTED"] = "GROUP_PROTECTED";
})(Enum || (Enum = {}));
export var BulkActionType;
(function (BulkActionType) {
    BulkActionType["UNKNOWN_ACTION_TYPE"] = "UNKNOWN_ACTION_TYPE";
    BulkActionType["INSERT"] = "INSERT";
    BulkActionType["UPDATE"] = "UPDATE";
    BulkActionType["DELETE"] = "DELETE";
})(BulkActionType || (BulkActionType = {}));
export var DescriptionFieldSet;
(function (DescriptionFieldSet) {
    DescriptionFieldSet["STANDARD"] = "STANDARD";
    DescriptionFieldSet["EXTENDED"] = "EXTENDED";
})(DescriptionFieldSet || (DescriptionFieldSet = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map